export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT = 'LOGOUT';
export const LOAD_USER = 'LOAD_USER';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
// for socket io
export const EMIT_EVENT = 'EMIT_EVENT';
export const FETCH_EVENT = 'FETCH_EVENT';
export const CONNECT_BACKEND = 'CONNECT_BACKEND';
export const GOT_SOCKET_ONLINE_USERS = 'GOT_SOCKET_ONLINE_USERS';
